<template>
  <Drawer :drawer="drawer" :withHeader="false" :size="744" @close="close">
    <div class="view">
      <div class="content scrollbar">
        <p class="title">
          <span>填报ISF</span>
          <span class="tpl" @click="dialogVisible2 = true">
            <img src="@/assets/images/bill/tpl.png" width="20px" />
            使用模板
          </span>
        </p>
        <el-form
          ref="form"
          class="form"
          :model="isf"
          :rules="rules"
          label-position="top"
        >
          <div class="row">
            <el-form-item label="OnBoard Date(开船日期)" prop="onBoardDate">
              <el-date-picker
                v-model="isf.onBoardDate"
                style="width: 160px"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="Bill Number Type(提单类型)"
              prop="classification"
              required
            >
              <el-select
                v-model="isf.classification"
                filterable
                style="width: 228px"
              >
                <el-option
                  v-for="(item, $index) in config.billNumberTypeOptions"
                  :key="$index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户" prop="companyId">
              <el-select
                v-model="isf.companyId"
                filterable
                style="width: 228px;"
                placeholder="请选择客户"
                @change="handleChange"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="AMS SCAC(AMS代码)" prop="amsscac" required>
              <el-input
                v-model="isf.amsscac"
                maxlength="4"
                style="width: 160px"
              />
            </el-form-item>
            <el-form-item label="AMS No.(AMS号码)" prop="amsblNumber" required>
              <el-input
                v-model="isf.amsblNumber"
                maxlength="12"
                style="width: 228px"
              />
            </el-form-item>
            <el-form-item label="Importer Bond Type(磅的类型)" prop="bondType">
              <el-select v-model="isf.bondType" filterable style="width: 228px">
                <el-option
                  v-for="(item, $index) in config.bondTypeOptions"
                  :key="$index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item v-if="isf.classification === 1" label="主提单号" prop="mblNo" required>
              <el-input
                v-model="isf.mblNo"
                style="width: 160px"
              />
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item prop="consigneeName" style="width: 100%">
              <template slot="label">
                <div class="lable">
                  <span>Consignee(收货人)</span>
                </div>
              </template>
              <el-select v-model="isf.consigneeName" style="width: 100%;" filterable clearable placeholder="请选择">
                <el-option
                  v-for="(item, index) in consigneeOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.name">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ item?.address | formatStatusAddress }}
                    {{ item?.cityAddress | formatStatusAddress }}
                    {{ item?.provinceEnName | formatStatusAddress }}
                    {{ item?.countryName | formatStatusAddress }}
                    <strong>{{ item?.postcode ? item?.postcode : "" }}</strong>
                  </span>
                </el-option>
              </el-select>
              <!-- <custom-select
                v-model="isf.consigneeName"
                :value="isf.consigneeName"
                :selectItems="consigneeOptions"
                dropdownWidth="662"
                placeholder="请选择"
                style="width: 100%"
              ></custom-select> -->
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item prop="importerName" style="width: 100%">
              <template slot="label">
                <div class="lable">
                  <span>Importer(进口商)</span>
                </div>
              </template>
              <el-select v-model="isf.importerName" style="width: 100%;" filterable clearable placeholder="请选择">
                <el-option
                  v-for="(item, index) in importerOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.name">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ item?.address | formatStatusAddress }}
                    {{ item?.cityAddress | formatStatusAddress }}
                    {{ item?.provinceEnName | formatStatusAddress }}
                    {{ item?.countryName | formatStatusAddress }}
                    <strong>{{ item?.postcode ? item?.postcode : "" }}</strong>
                  </span>
                </el-option>
              </el-select>
              <!-- <custom-select
                v-model="isf.importerName"
                :value="isf.importerName"
                :selectItems="importerOptions"
                :showEin="true"
                dropdownWidth="662"
                placeholder="请选择"
                style="width: 100%"
              ></custom-select> -->
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item prop="buyerName" style="width: 100%">
              <template slot="label">
                <div class="lable">
                  <span>Buyer(买家)</span>
                </div>
              </template>
              <el-select v-model="isf.buyerName" style="width: 100%;" filterable clearable placeholder="请选择">
                <el-option
                  v-for="(item, index) in buyerNameOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.name">
                   <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ item?.address | formatStatusAddress }}
                    {{ item?.cityAddress | formatStatusAddress }}
                    {{ item?.provinceEnName | formatStatusAddress }}
                    {{ item?.countryName | formatStatusAddress }}
                    <strong>{{ item?.postcode ? item?.postcode : "" }}</strong>
                  </span>
                </el-option>
              </el-select>
              <!-- <custom-select
                v-model="isf.buyerName"
                :value="isf.buyerName"
                :selectItems="buyerNameOptions"
                dropdownWidth="662"
                placeholder="请选择"
                style="width: 100%"
              ></custom-select> -->
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item prop="sellingName" style="width: 100%">
              <template slot="label">
                <div class="lable">
                  <span>Selling Party(卖家)</span>
                </div>
              </template>
              <el-select v-model="isf.sellingName" style="width: 100%;" filterable clearable placeholder="请选择">
                <el-option
                  v-for="(item, index) in sellingNameOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.name">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ item?.address | formatStatusAddress }}
                    {{ item?.cityAddress | formatStatusAddress }}
                    {{ item?.provinceEnName | formatStatusAddress }}
                    {{ item?.countryName | formatStatusAddress }}
                    <strong>{{ item?.postcode ? item?.postcode : "" }}</strong>
                  </span>
                </el-option>
              </el-select>
              <!-- <custom-select
                v-model="isf.sellingName"
                :value="isf.sellingName"
                :selectItems="sellingNameOptions"
                dropdownWidth="662"
                placeholder="请选择"
                style="width: 100%"
              ></custom-select> -->
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item prop="shipToPartyName" style="width: 100%">
              <template slot="label">
                <div class="lable">
                  <span>Ship To Party(通知人)</span>
                </div>
              </template>
              <el-select v-model="isf.shipToPartyName" style="width: 100%;" filterable clearable placeholder="请选择">
                <el-option
                  v-for="(item, index) in shipToPartyNameOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.name">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ item?.address | formatStatusAddress }}
                    {{ item?.cityAddress | formatStatusAddress }}
                    {{ item?.provinceEnName | formatStatusAddress }}
                    {{ item?.countryName | formatStatusAddress }}
                    <strong>{{ item?.postcode ? item?.postcode : "" }}</strong>
                  </span>
                </el-option>
              </el-select>
              <!-- <custom-select
                v-model="isf.shipToPartyName"
                :value="isf.shipToPartyName"
                :selectItems="shipToPartyNameOptions"
                dropdownWidth="662"
                placeholder="请选择"
                style="width: 100%"
              ></custom-select> -->
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item prop="manufacturerName" style="width: 100%">
              <template slot="label">
                <div class="lable">
                  <span>Manufacture(制造商)</span>
                </div>
              </template>
              <el-select v-model="isf.manufacturerName" style="width: 100%;" filterable clearable placeholder="请选择">
                <el-option
                  v-for="(item, index) in manufacturerNameOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.name">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ item?.address | formatStatusAddress }}
                    {{ item?.cityAddress | formatStatusAddress }}
                    {{ item?.provinceEnName | formatStatusAddress }}
                    {{ item?.countryName | formatStatusAddress }}
                    <strong>{{ item?.postcode ? item?.postcode : "" }}</strong>
                  </span>
                </el-option>
              </el-select>
              <!-- <custom-select
                v-model="isf.manufacturerName"
                :value="isf.manufacturerName"
                :selectItems="manufacturerNameOptions"
                dropdownWidth="662"
                placeholder="请选择"
                style="width: 100%"
              ></custom-select> -->
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item prop="consolidatorName" style="width: 100%">
              <template slot="label">
                <div class="lable">
                  <span>Consolidator(拼柜地)</span>
                </div>
              </template>
              <el-select v-model="isf.consolidatorName" style="width: 100%;" filterable clearable placeholder="请选择">
                <el-option
                  v-for="(item, index) in consolidatorNameOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.name">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ item?.address | formatStatusAddress }}
                    {{ item?.cityAddress | formatStatusAddress }}
                    {{ item?.provinceEnName | formatStatusAddress }}
                    {{ item?.countryName | formatStatusAddress }}
                    <strong>{{ item?.postcode ? item?.postcode : "" }}</strong>
                  </span>
                </el-option>
              </el-select>
              <!-- <custom-select
                v-model="isf.consolidatorName"
                :value="isf.consolidatorName"
                :selectItems="consolidatorNameOptions"
                dropdownWidth="662"
                placeholder="请选择"
                style="width: 100%"
              ></custom-select> -->
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item prop="stuffingName" style="width: 100%">
              <template slot="label">
                <div class="lable">
                  <span>Container Staffing Location(装货地)</span>
                </div>
              </template>
              <el-select v-model="isf.stuffingName" style="width: 100%;" filterable clearable placeholder="请选择">
                <el-option
                  v-for="(item, index) in stuffingNameOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.name">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ item?.address | formatStatusAddress }}
                    {{ item?.cityAddress | formatStatusAddress }}
                    {{ item?.provinceEnName | formatStatusAddress }}
                    {{ item?.countryName | formatStatusAddress }}
                    <strong>{{ item?.postcode ? item?.postcode : "" }}</strong>
                  </span>
                </el-option>
              </el-select>
              <!-- <custom-select
                v-model="isf.stuffingName"
                :value="isf.stuffingName"
                :selectItems="stuffingNameOptions"
                dropdownWidth="662"
                placeholder="请选择"
                style="width: 100%"
              ></custom-select> -->
            </el-form-item>
          </div>
        </el-form>
        <base-panel
          class="panel"
          title="HS CODE列表"
          height="20px"
          fontSize="14px"
        >
          <ul>
            <li class="header">
              <div class="cell1"><span>* </span> 海关编码(6位)</div>
              <!-- <div class="cell2"><span>* </span>原产地国家二字代码</div>
              <div class="cell3">英文描述</div> -->
              <div class="cell4" @click="addItems">
                <svg-icon
                  iconClass="add"
                  className="icon"
                />
              </div>
            </li>
            <li v-for="(item, $index) in isf.htsItems" :key="$index">
              <div class="cell1">
                <el-input v-model="item.hsCode" maxlength="6" />
              </div>
              <div class="cell4" @click="deleteItems($index)">
                <i class="el-icon-delete icon" />
              </div>
            </li>
          </ul>
        </base-panel>
      </div>
      <div class="footer">
        <div class="btn btn1" @click="cancel">取消</div>
        <div class="btn btn3" @click="save">存为模板</div>
        <div class="btn btn2" @click="ok">确定</div>
      </div>
      <!-- <warehouseadd-dialog
        :dialogVisible="dialogVisible"
        :activeName="warehouseType.toString()"
        @ok="ok2"
        @cancel="dialogVisible = false"
      ></warehouseadd-dialog> -->
      <SaveIsfTplDialog
        :dialogVisible="dialogVisible1"
        :isfTpl="isfTpl"
        @ok="dialogVisible1 = false"
        @cancel="dialogVisible1 = false"
      >
      </SaveIsfTplDialog>
      <SaveIsfTplListDialog
        :dialogVisible="dialogVisible2"
        @ok="ok3"
        @cancel="dialogVisible2 = false"
      >
      </SaveIsfTplListDialog>
    </div>
  </Drawer>
</template>

<script>
const Drawer = () => import('@/components/drawer/Drawer')
const BasePanel = () => import('@/components/panel/BasePanel.vue')
import config from '@/utils/config'
// const WarehouseaddDialog = () =>
//   import('@/components/dialog/WarehouseaddDialog.vue')
// import CustomSelect from './CustomSelect.vue'
import SaveIsfTplDialog from './SaveIsfTplDialog.vue'
import SaveIsfTplListDialog from './SaveIsfTplListDialog.vue'
import { create, getDetail } from '@/api/bill'
import { getScinList } from '@/api/basic'
import { getImporterDrapdown } from '@/api/system'
export default {
  components: {
    Drawer,
    BasePanel,
    // CustomSelect,
    SaveIsfTplListDialog,
    SaveIsfTplDialog
  },
  filters: {
    formatStatusAddress(val) {
      return val ? val + ',' : ''
    }
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    companyList: {
      type: Array,
      require: true
    },
    shipmentFileNumber: {
      type: String,
      default: ''
    },
    rowData: {
      type: Object,
      require: false
    }
  },
  data() {
    return {
      config,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      warehouseType: 3,
      isf: {
        bondType: 0,
        classification: 0,
        companyId: '',
        onBoardDate: '',
        importerName: '',
        importerEIN: '',
        manufacturerName: '',
        sellingName: '',
        buyerName: '',
        shipToPartyName: '',
        consolidatorName: '',
        stuffingName: '',
        consigneeName: '',
        amsscac: '',
        amsblNumber: '',
        htsItems: [
          {
            hsCode: '',
            nameEN: '',
            originCountryCode: ''
          }
        ]
      },
      rules: {
        bondType: [
          {
            required: true,
            message: '请选择Importer Bond Type',
            trigger: 'change'
          }
        ],
        onBoardDate: [
          { required: true, message: '请选择登船日期', trigger: 'change' }
        ],
        importerName: [
          { required: true, message: '请选择进口商', trigger: 'change' }
        ],
        manufacturerName: [
          { required: true, message: '请选择制造商', trigger: 'change' }
        ],
        sellingName: [
          { required: true, message: '请选择卖家', trigger: 'change' }
        ],
        buyerName: [
          { required: true, message: '请选择买家', trigger: 'change' }
        ],
        shipToPartyName: [
          { required: true, message: '请选择货物送达方', trigger: 'change' }
        ],
        consolidatorName: [
          { required: true, message: '请选择拼货方', trigger: 'change' }
        ],
        stuffingName: [
          { required: true, message: '请选择装货地', trigger: 'change' }
        ],
        consigneeName: [
          { required: true, message: '请选择收货/件方', trigger: 'change' }
        ],
        amsscac: [
          { required: true, message: '请输入AMSS CAC', trigger: 'blur' }
        ],
        amsblNumber: [
          { required: true, message: '请输入AMS No', trigger: 'blur' }
        ]
      },
      isfTpl: {},
      scinList: [],
      importerList: []
    }
  },
  computed: {
    consigneeOptions() {
      return this.scinList
        .filter((a) => a.type.indexOf(1) > -1)
        .map((item) => {
          // item.name = item.companyName
          return item
        })
    },
    importerOptions() {
      return this.importerList
    },
    buyerNameOptions() {
      return this.scinList
        .filter((a) => a.type.indexOf(6) > -1)
        .map((item) => {
          // item.name = item.companyName
          return item
        })
    },
    sellingNameOptions() {
      return this.scinList
        .filter((a) => a.type.indexOf(7) > -1)
        .map((item) => {
          // item.name = item.companyName
          return item
        })
    },
    shipToPartyNameOptions() {
      return this.scinList
        .filter((a) => a.type.indexOf(8) > -1)
        .map((item) => {
          // item.name = item.companyName
          return item
        })
    },
    manufacturerNameOptions() {
      return this.scinList
        .filter((a) => a.type.indexOf(4) > -1)
        .map((item) => {
          // item.name = item.companyName
          return item
        })
    },
    consolidatorNameOptions() {
      return this.scinList
        .filter((a) => a.type.indexOf(9) > -1)
        .map((item) => {
          // item.name = item.companyName
          return item
        })
    },
    stuffingNameOptions() {
      return this.scinList
        .filter((a) => a.type.indexOf(10) > -1)
        .map((item) => {
          // item.name = item.companyName
          return item
        })
    }
    // ...mapGetters(['addressBookOptions']),
    // consigneeOptions() {
    //   console.log(
    //     'this.addressBookOptions[0]',
    //     this.addressBookOptions
    //   )
    //   return this.addressBookOptions[0].filter(
    //       (a) =>
    //         a.type === 20 &&
    //         a.scinTypes.indexOf(3) > -1
    //     )
    //     .map((item) => {
    //       item.label = item.companyName
    //       return item
    //     })
    // },
    // importerOptions() {
    //   return this.addressBookOptions[0].filter(
    //       (a) =>
    //         a.type === 20 &&
    //         a.scinTypes.indexOf(4) > -1
    //     )
    //     .map((item) => {
    //       item.label = item.companyName
    //       return item
    //     })
    // },
    // buyerNameOptions() {
    //   return this.addressBookOptions[0].filter(
    //       (a) =>
    //         a.type === 20 &&
    //         a.scinTypes.indexOf(5) > -1
    //     )
    //     .map((item) => {
    //       item.label = item.companyName
    //       return item
    //     })
    // },
    // sellingNameOptions() {
    //   return this.addressBookOptions[0].filter(
    //       (a) =>
    //         a.type === 20 &&
    //         a.scinTypes.indexOf(6) > -1
    //     )
    //     .map((item) => {
    //       item.label = item.companyName
    //       return item
    //     })
    // },
    // shipToPartyNameOptions() {
    //   return this.addressBookOptions[0].filter(
    //       (a) =>
    //         a.type === 20 &&
    //         a.scinTypes.indexOf(9) > -1
    //     )
    //     .map((item) => {
    //       item.label = item.companyName
    //       return item
    //     })
    // },
    // manufacturerNameOptions() {
    //   return this.addressBookOptions[0].filter(
    //       (a) =>
    //         a.type === 20 &&
    //         a.scinTypes.indexOf(7) > -1
    //     )
    //     .map((item) => {
    //       item.label = item.companyName
    //       return item
    //     })
    // },
    // consolidatorNameOptions() {
    //   return this.addressBookOptions[0].filter(
    //       (a) =>
    //         a.type === 20 &&
    //         a.scinTypes.indexOf(8) > -1
    //     )
    //     .map((item) => {
    //       item.label = item.companyName
    //       return item
    //     })
    // },
    // stuffingNameOptions() {
    //   return this.addressBookOptions[0].filter(
    //       (a) =>
    //         a.type === 20 &&
    //         a.scinTypes.indexOf(10) > -1
    //     )
    //     .map((item) => {
    //       item.label = item.companyName
    //       return item
    //     })
    // }
  },
  watch: {
    drawer: {
     async handler(val) {
        if (val) {
          if (this.rowData.onBoardDate) {
            if (this.shipmentFileNumber) {
              this.isf['shipmentFileNumber'] = this.shipmentFileNumber
              this.getDetail(this.shipmentFileNumber)
            }
            this.isf = {
              mblNo: this.rowData.mblNo,
              onBoardDate: this.rowData.onBoardDate,
              classification: this.rowData.classification,
              amsscac: this.rowData.amsscac,
              amsblNumber: this.rowData.amsblNumber,
              bondType: this.rowData.bondType,
              companyId: this.rowData.companyId,
              consigneeName: this.rowData.consigneeNameAddress.name,
              importerName: this.rowData.importerNameAddress.name,
              importerEIN: this.rowData.taxNo,
              buyerName: this.rowData.buyerNameAddress.name,
              sellingName: this.rowData.sellingNameAddress.name,
              shipToPartyName: this.rowData.shipToPartyNameAddress.name,
              manufacturerName: this.rowData.manufacturerNameAddress.name,
              consolidatorName: this.rowData.consolidatorNameAddress.name,
              stuffingName: this.rowData.stuffingNameAddress.name,
              htsItems: this.isf.htsItems || []
            }
          }
          this.getScinData()
          this.getImporterData()
          // this.isf.consigneeName = this.consigneeName
          // this.isf.shipToPartyName = this.shipperName
          // this.isf.amsscac = this.blNo.slice(0, 4)
          // this.isf.amsblNumber = this.blNo.slice(4, this.blNo.length)
        }
      }
    }
  },
  created() {
    // if (this.addressBookOptions && this.addressBookOptions.length === 0) {
    //   this.$store.dispatch('getAddressBookOptions', -1)
    // }
  },
  methods: {
    async getScinData() {
      try {
        const res = await getScinList()
        if (res.success) {
          this.scinList = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getImporterData() {
      try {
        const res = await getImporterDrapdown({ status: 4 })
        if (res.success) {
          this.importerList = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getDetail(shipmentFileNumber) {
      try {
        const res = await getDetail({ shipmentFileNumber })
        if (res.success) {
          const result = res.data && res.data.htsItems.map(item => {
            item.originCountryCode = item.countryCode
            delete item.countryCode
            return {
              originCountryCode: item.originCountryCode,
              hsCode: item.hsCode,
              nameEN: item.nameEN
            }
          })
          this.isf.htsItems = result
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (erroe) {
        console.error(erroe)
      }
    },
    cancel() {
      this.reset()
      this.$emit('close')
    },
    ok() {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          let flag = true
          const htsItemsArr = []
          const htsItemLength = [6, 8, 10]
          this.isf.htsItems.forEach((item) => {
            // if (!(item.hsCode && item.originCountryCode && item.originCountryCode.length === 2)) {
            //   flag = false
            // }
            if (htsItemLength.indexOf(item.hsCode.length) === -1) {
              flag = false
            }
            // item.originCountryCode = this.manufacturerNameOptions.find(
            //   (a) => a.companyName === this.isf.manufacturerName
            // )?.countryCode
            // item.nameEN = '1'
            htsItemsArr.push(item.hsCode)
          })
          if (!flag) {
            this.$message.warning(
              'HS CODE列表不完整, 海关编码必须6、8或者10位, 国家代码必须为二字代码'
            )
            return
          }
          if (htsItemsArr.length !== Array.from(new Set(htsItemsArr)).length) {
            this.$message.warning('HS CODE存在相同的海关编码')
            return
          }
          const importerEIN = this.importerOptions.find(
            (a) => a.name === this.isf.importerName
          )?.taxNo
          if (!importerEIN) {
            this.$message.warning('Importer 不含税号，重新选择')
            return
          }
          const consigneeName = {
            scin: this.consigneeOptions.find(a => a.name === this.isf.consigneeName),
            type: 1
          }
          const importerName = {
            importer: this.importerOptions.find(a => a.name === this.isf.importerName),
            type: 2
          }
          const manufacturerName = {
            scin: this.manufacturerNameOptions.find(a => a.name === this.isf.manufacturerName),
            type: 4
          }
          const sellingName = {
            scin: this.sellingNameOptions.find(a => a.name === this.isf.sellingName),
            type: 7
          }
          const buyerName = {
            scin: this.buyerNameOptions.find(a => a.name === this.isf.buyerName),
            type: 6
          }
          const shipToPartyName = {
            scin: this.shipToPartyNameOptions.find(a => a.name === this.isf.shipToPartyName),
            type: 8
          }
          const consolidatorName = {
            scin: this.consolidatorNameOptions.find(a => a.name === this.isf.consolidatorName),
            type: 9
          }
          const stuffingName = {
            scin: this.stuffingNameOptions.find(a => a.name === this.isf.stuffingName),
            type: 10
          }

          const parties = [consigneeName, importerName, manufacturerName, sellingName, buyerName, shipToPartyName, consolidatorName, stuffingName]
          console.log('consigneeName', consigneeName)
          const params = {
            mblNo: this.isf.classification ? this.isf.mblNo : this.isf.amsscac + this.isf.amsblNumber,
            shipmentFileNumber: this.shipmentFileNumber || undefined,
            classification: this.isf.classification,
            companyId: this.isf.companyId,
            bondType: this.isf.bondType,
            onBoardDate: this.isf.onBoardDate,
            amsscac: this.isf.amsscac,
            amsblNumber: this.isf.amsblNumber,
            // htsItems: this.isf.htsItems,
            parties: parties,
            hsCodes: htsItemsArr
          }
          try {
            const res = await create(params)
            if (res.success) {
              this.$message.success('新增成功')
              this.$emit('ok')
              this.reset()
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.log(error)
          }
          // this.$emit('ok', params)
        }
      })
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let flag = true
          const htsItemsArr = []
          const htsItemLength = [6, 8, 10]
          this.isf.htsItems.forEach((item) => {
            // if (!(item.hsCode && item.originCountryCode && item.originCountryCode.length === 2)) {
            //   flag = false
            // }
            if (htsItemLength.indexOf(item.hsCode.length) === -1) {
              flag = false
            }
            item.originCountryCode = this.manufacturerNameOptions.find(
              (a) => a.name === this.isf.manufacturerName
            )?.countryCode
            item.nameEN = '1'
            htsItemsArr.push(item.hsCode)
          })
          if (!flag) {
            this.$message.warning(
              'HS CODE列表不完整, 海关编码必须6、8或者10位'
            )
            return
          }
          if (htsItemsArr.length !== Array.from(new Set(htsItemsArr)).length) {
            this.$message.warning('HS CODE存在相同的海关编码')
            return
          }
          const importerEIN = this.importerOptions.find(
            (a) => a.name === this.isf.importerName
          )?.taxNo
          if (!importerEIN) {
            this.$message.warning('Importer 不含税号，重新选择')
            return
          }
          this.isfTpl = {
            importerName: this.isf.importerName,
            importerEIN: this.isf.importerEIN,
            manufacturerName: this.isf.manufacturerName,
            sellingName: this.isf.sellingName,
            buyerName: this.isf.buyerName,
            shipToPartyName: this.isf.shipToPartyName,
            consolidatorName: this.isf.consolidatorName,
            stuffingName: this.isf.stuffingName,
            consigneeName: this.isf.consigneeName
          }
          this.dialogVisible1 = true
        }
      })
    },
    reset() {
      this.$refs['form']?.resetFields()
      this.isf.htsItems = [
          {
            hsCode: '',
            nameEN: '',
            originCountryCode: ''
          }
        ]
    },
    close() {
      this.reset()
      this.$emit('close')
    },
    addItems() {
      this.isf.htsItems.push({
        hsCode: '',
        nameEN: '',
        originCountryCode: ''
      })
    },
    deleteItems(index) {
      this.isf.htsItems.splice(index, 1)
    },
    async ok2() {
      await this.$store.dispatch('getAddressBookOptions', -1)
      this.dialogVisible = false
    },
    add(type) {
      this.warehouseType = type
      this.dialogVisible = true
    },
    ok3(params) {
      this.dialogVisible2 = false
      this.isf = {
        ...JSON.parse(params),
        htsItems: [
          {
            hsCode: ''
          }
        ],
        classification: 0,
        bondTypeOptions: 0,
        amsscac: this.isf.amsscac,
        amsblNumber: this.isf.amsblNumber
      }
    },
    async handleChange() {
      await this.$store.dispatch('getAddressBookOptions', { type: -1 })
      const obj = {
        consigneeName: '',
        importerName: '',
        importerEIN: '',
        buyerName: '',
        sellingName: '',
        shipToPartyName: '',
        manufacturerName: '',
        consolidatorName: '',
        stuffingName: ''
      }
      this.isf = {
        ...this.isf,
        ...obj
      }
    }
  }
}
</script>

<style lang="less" scoped>
.view {
  width: 100%;
  height: 100%;
  position: relative;
  .content {
    width: calc(100%);
    height: calc(100% - 138px);
    padding: 24px 0;
    overflow: auto;
  }
  .title {
    width: calc(100% - 80px);
    margin: 0 auto;
    height: 24px;
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #25396f;
    line-height: 24px;
    display: flex;
    justify-content: space-between;
    .tpl {
      display: inline-block;
      width: 100px;
      height: 32px;
      background: #35ba83;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      font-size: 14px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
      img {
        vertical-align: -5px;
      }
    }
  }
  .form {
    width: calc(100% - 80px);
    margin: 16px auto 0;
  }
  .row {
    width: calc(100% + 14px);
    display: flex;
    justify-content: space-between;
  }
  .panel-content {
    ul {
      width: calc(100% + 14px);
      border-radius: 6px;
      overflow: hidden;
    }
  }
  .lable {
    width: 100%;
    height: 32px;
    line-height: 32px;
    display: flex;
    justify-content: space-between;
  }
  .add {
    height: 100%;
    line-height: 32px;
    cursor: pointer;
    color:  rgb(18,88,188);
    .icon {
      font-size: 20px;
      margin-right: 4px;
      vertical-align: text-top;
    }
  }
  ul {
    border: 1px solid #dbe4f2;
  }
  li {
    width: 100%;
    height: 48px;
    border-bottom: 1px solid #dbe4f2;
    display: flex;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #25396f;
    line-height: 48px;
    text-align: center;
    &:last-child {
      border-bottom: 0;
    }
    .cell1 {
      width: calc(100% - 55px);
      height: 100%;
      border-right: 1px solid #dbe4f2;
    }
    .cell4 {
      width: 55px;
      height: 100%;
      cursor: pointer;
    }
    .icon {
      font-size: 20px;
      color: #b8c3de;
    }
    span {
      color: #ff7444;
    }
    &:deep(.el-input__inner) {
      border: 0;
      height: 48px;
      line-height: 48px;
    }
  }
  .header {
    background: #f8fbff;
  }
  &:deep(.el-form--label-top .el-form-item__label) {
    padding: 0;
    line-height: 32px;
    font-weight: 400;
    color: #25396f;
    position: relative;
    z-index: 2000;
    display: flex;
  }
  &:deep(.el-form-item) {
    margin-bottom: 16px;
  }
  .footer {
    width: 100%;
    height: 90px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
    border-radius: 0px 0px 6px 6px;
    opacity: 1;
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    position: absolute;
    .btn {
      width: 100px;
      height: 38px;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      line-height: 40px;
      cursor: pointer;
      text-align: center;
      & + .btn {
        margin-left: 16px;
      }
    }
    .btn1 {
      background: #f2f7ff;
      color: #7c8db5;
      border: 1px solid #dbe4f2;
    }
    .btn2 {
      color: #ffffff;
      background:  rgb(18,88,188);
      border: 1px solid  rgb(18,88,188);
    }
    .btn3 {
      border: 1px solid  rgb(18,88,188);
      background: #ffffff;
      color:  rgb(18,88,188);
    }
  }
}

  .tips {
    display: inline-block;
    width: auto;
    height: 20px;
    font-size: 12px;
    line-height: 20px;
    padding: 0 12px;
  }
  .tips-owner {
    color: rgba(53, 186, 131, 1);
    background: rgba(53, 186, 131, .1);
  }
  .tips-out {
    color: rgba(254, 69, 61, 1);
    background: rgba(254, 69, 61, .1);
  }
</style>
